
var sbn = angular.module('nomenclature.sbn', ['common.directive.gonoTree'])
        .controller('SearchByNomenclatureController', function (CONSTANTS, $translatePartialLoader, SearchByNomenclatureModel, preferredUILanguages, links, $stateParams, $uibModal, CommonHelper, $state, GoodsNomenclatureTreeModel, $filter, $translate, $location, $anchorScroll) {
    var searchByNomenclatureCtrl = this;
    searchByNomenclatureCtrl.init = function () {
        searchByNomenclatureCtrl.searchCriteria = SearchByNomenclatureModel.getSearchCriteria();
        searchByNomenclatureCtrl.links = links.items;
        searchByNomenclatureCtrl.languages = preferredUILanguages.items;
        searchByNomenclatureCtrl.dateFormat = CONSTANTS.dateFormat;
        searchByNomenclatureCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
        searchByNomenclatureCtrl.gonoTreeConfig = CONSTANTS.gonoTree;
        searchByNomenclatureCtrl.searchCriteria.language = CommonHelper.getValidSelectedItem(
            searchByNomenclatureCtrl.languages,
            searchByNomenclatureCtrl.searchCriteria.language,
            CommonHelper.getLanguageCode(CONSTANTS.availableLanguages[0]));
        searchByNomenclatureCtrl.updateExpandAll();
        searchByNomenclatureCtrl.search();
    };

    searchByNomenclatureCtrl.search = function(){
        searchByNomenclatureCtrl.errorCode = CommonHelper.validateCommodityCode(searchByNomenclatureCtrl.searchCriteria.commodityCode , searchByNomenclatureCtrl.searchCriteria.direction);
        if (searchByNomenclatureCtrl.errorCode){
            return;
        }
        if (!CONSTANTS.dateRestrictionEnabled) {
            searchByNomenclatureCtrl.errorCode = CommonHelper.validateSimulationDate(searchByNomenclatureCtrl.searchCriteria.simulationDate);
            if (searchByNomenclatureCtrl.errorCode){
                searchByNomenclatureCtrl.errorParams = {param0: CONSTANTS.pastDate};
                return;
            }
        }
        searchByNomenclatureCtrl.searching = true;
        searchByNomenclatureCtrl.treeDataList = null;
        SearchByNomenclatureModel.searchGoodsNomenclature(searchByNomenclatureCtrl.searchCriteria.commodityCode,
            searchByNomenclatureCtrl.searchCriteria.direction,
            searchByNomenclatureCtrl.searchCriteria.simulationDate,
            searchByNomenclatureCtrl.searchCriteria.language
        ).then(function (result) {
            searchByNomenclatureCtrl.treeDataList = GoodsNomenclatureTreeModel.buildGonoTree(result.items, searchByNomenclatureCtrl.searchCriteria.commodityCode, searchByNomenclatureCtrl.searchCriteria.expandAll);
            searchByNomenclatureCtrl.searching = false;
            searchByNomenclatureCtrl.checkForCommodityCodeExistence();
            if(searchByNomenclatureCtrl.treeDataList){
                searchByNomenclatureCtrl.treeDataList.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchByNomenclatureCtrl.searchCriteria.simulationDate);
                if (searchByNomenclatureCtrl.treeDataList.infoCode &&
                    "i8n.common.pastDate" === searchByNomenclatureCtrl.treeDataList.infoCode) {
                    searchByNomenclatureCtrl.treeDataList.infoParams = CONSTANTS.pastDate;
                }
            }

            searchByNomenclatureCtrl.updateBrowserURL();
        }, function (error) {
            searchByNomenclatureCtrl.errorCode = error.data.code;
            searchByNomenclatureCtrl.errorParams = error.data.params;
            searchByNomenclatureCtrl.searching = false;
            searchByNomenclatureCtrl.remapErrorParameters();
        });
    };

    /**
     * Search goods nomenclature
     * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/nomenclature/sbn?sd={SimulationDate}&d={TradeDirection}&cc={CommodityCode}&l={Language}&ql={QueryLanguage}&ea={ExpandAllSearchResults}
     *
     * Example:
     * http://www.testenv.se/arctictariff-public-web/#!/taric/nomenclature/sbn?sd=2015-01-01&d=I&cc=1005109000&l=en&ql=en&ea=true
     */
    searchByNomenclatureCtrl.updateBrowserURL = function(){
        if (!CONSTANTS.enableBookmark){
            return;
        }
        // Keep additional parameters 'frm', 'type', 'ccField' to return to caller page.
        $location.search({
            sd: CommonHelper.getBookmarkDateString(searchByNomenclatureCtrl.searchCriteria.simulationDate),
            d : searchByNomenclatureCtrl.searchCriteria.direction,
            cc: CommonHelper.removeSpaceCharacters(searchByNomenclatureCtrl.searchCriteria.commodityCode),
            l : $translate.use(),
            ql: searchByNomenclatureCtrl.searchCriteria.language,
            ea: searchByNomenclatureCtrl.searchCriteria.expandAll.toString(),
            frm: $stateParams.frm,
            type: $stateParams.type,
            ccField: $stateParams.ccField
        }).replace();

    };

    searchByNomenclatureCtrl.openDatePicker = function ($event) {
        searchByNomenclatureCtrl.isDatePickerOpen = true;
    };
    searchByNomenclatureCtrl.getScreenType = function(){
        return $stateParams.type;
    };

    searchByNomenclatureCtrl.returnToCallerPage = function (commodityCode) {
        var ccFieldName = $stateParams.ccField;
        if (searchByNomenclatureCtrl.getScreenType() === 'lookup' || searchByNomenclatureCtrl.getScreenType() === 'declarableCommodityCodeLookup') {
            $state.go($stateParams.frm,
                {
                    cc: CommonHelper.removeSpaceCharacters(commodityCode),
                    sd: CommonHelper.getBookmarkDateString(searchByNomenclatureCtrl.searchCriteria.simulationDate),
                    d: searchByNomenclatureCtrl.searchCriteria.direction,
                    ccField: ccFieldName,
                    frm: 'ccLookup'
                });
        } else {
            $state.go($stateParams.frm, {frm : 'ccView'});
        }
    };

    searchByNomenclatureCtrl.isLeafNodeClickable = function () {
        return  searchByNomenclatureCtrl.getScreenType() !== 'lookup' &&
                    searchByNomenclatureCtrl.getScreenType() !== 'declarableCommodityCodeLookup';
    };

    searchByNomenclatureCtrl.invokedFromOtherScreen = function () {
        return !!$stateParams.frm;
    };

    searchByNomenclatureCtrl.shouldDisplayExportRefund = function () {
        return $stateParams.type !== 'lookup' && $stateParams.type !== 'declarableCommodityCodeLookup';
    };

    searchByNomenclatureCtrl.resetError = function(){
        searchByNomenclatureCtrl.handleError(null);
    };

    searchByNomenclatureCtrl.handleError = function(error){
        if(!error){
            searchByNomenclatureCtrl.errorCode = null;
            searchByNomenclatureCtrl.errorParams = null;
        } else {
            searchByNomenclatureCtrl.errorCode = error.errorCode;
            searchByNomenclatureCtrl.errorParams = error.errorParams;
        }
    };

    searchByNomenclatureCtrl.formatCommodityCode = function(){
        var formattedCommodityCode = $filter('commodityCode')(searchByNomenclatureCtrl.searchCriteria.commodityCode);
        searchByNomenclatureCtrl.searchCriteria.commodityCode = formattedCommodityCode;
    };

    searchByNomenclatureCtrl.onCommodityCodeChange = function(){
        searchByNomenclatureCtrl.formatCommodityCode();
        searchByNomenclatureCtrl.updateExpandAll();
    };

    searchByNomenclatureCtrl.updateExpandAll = function(){
        var commodityCode = CommonHelper.removeSpaceCharacters(searchByNomenclatureCtrl.searchCriteria.commodityCode);
        searchByNomenclatureCtrl.shouldEnableExpandAll = commodityCode.length >= 2;
        if (!searchByNomenclatureCtrl.shouldEnableExpandAll){
            searchByNomenclatureCtrl.searchCriteria.expandAll = false;
        }
    };

    searchByNomenclatureCtrl.checkForCommodityCodeExistence = function(){
        if (searchByNomenclatureCtrl.treeDataList === null || searchByNomenclatureCtrl.treeDataList.length === 0){
            searchByNomenclatureCtrl.errorCode = "tqf.cc.notFound";
            searchByNomenclatureCtrl.errorParams = {param0: searchByNomenclatureCtrl.searchCriteria.commodityCode, param1: searchByNomenclatureCtrl.searchCriteria.commodityCode};
        }
    };

    searchByNomenclatureCtrl.remapErrorParameters = function(){
        if (searchByNomenclatureCtrl.errorCode === "tqf.cc.notFound"){
            searchByNomenclatureCtrl.errorParams = {param0: searchByNomenclatureCtrl.searchCriteria.commodityCode, param1: searchByNomenclatureCtrl.searchCriteria.commodityCode};
        }
    };

    searchByNomenclatureCtrl.onDateChange = function(dateString){
        searchByNomenclatureCtrl.resetError();
        searchByNomenclatureCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchByNomenclatureCtrl.searchCriteria.simulationDate, dateString);
        if (searchByNomenclatureCtrl.searchCriteria.simulationDate){
            SearchByNomenclatureModel.getLinks(searchByNomenclatureCtrl.searchCriteria.simulationDate).then(function (links) {
                searchByNomenclatureCtrl.links = links.items;
            }, function (error) {
                searchByNomenclatureCtrl.errorCode = error.data.code;
                searchByNomenclatureCtrl.errorParams = error.data.params;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./app/taric/nomenclature/sbn/nomenclature-sbn.js